"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _LocationsUtil = require("../../utils/LocationsUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdFormMap = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(AdFormMap, _Component);

  function AdFormMap() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AdFormMap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AdFormMap.__proto__ || (0, _getPrototypeOf2.default)(AdFormMap)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      map: null,
      marker: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AdFormMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var map = new google.maps.Map(this.mapNode, {
        center: this.getCoordinates(),
        zoom: 12,
        disableDefaultUI: true,
        zoomControl: true,
        scrollwheel: false
      });
      this.setState({ map: map }, function () {
        _this2.createMarker();
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _props = this.props,
          latitude = _props.latitude,
          longitude = _props.longitude;
      var _state = this.state,
          map = _state.map,
          marker = _state.marker;


      if (map && marker && (0, _LocationsUtil.legitCoordinates)(latitude, longitude)) {
        var coordinates = this.getCoordinates();
        marker.setPosition(coordinates);
        map.setCenter(coordinates);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement("div", { ref: function ref(node) {
          return _this3.mapNode = node;
        }, className: "map" });
    }
  }, {
    key: "createMarker",
    value: function createMarker() {
      var _this4 = this;

      var marker = new google.maps.Marker({
        map: this.state.map,
        title: "Työmaan sijainti",
        draggable: true,
        position: this.getCoordinates(),
        icon: "/img/maaporssi-map-marker.png"
      });

      marker.addListener("dragend", function (event) {
        _this4.props.handleMarkerDrag({
          latitude: event.latLng.lat(),
          longitude: event.latLng.lng()
        });
      });

      this.setState({ marker: marker });
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      var _props2 = this.props,
          latitude = _props2.latitude,
          longitude = _props2.longitude;

      if ((0, _LocationsUtil.legitCoordinates)(latitude, longitude)) {
        return {
          lat: latitude,
          lng: longitude
        };
      } else {
        return (0, _LocationsUtil.getCoordinates)("Helsinki");
      }
    }
  }]);
  return AdFormMap;
}(_react.Component), _class.propTypes = {
  handleMarkerDrag: _react.PropTypes.func.isRequired,
  latitude: _react.PropTypes.number,
  longitude: _react.PropTypes.number
}, _temp2);
exports.default = AdFormMap;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/map/AdFormMap.js
 ** module id = 1156
 ** module chunks = 0
 **/